module.exports = __webpack_public_path__ + "img/gfbank.3114e126.png";